import { h, Component } from 'preact'; // eslint-disable-line no-unused-vars
import { PreactHTMLConverter } from 'preact-html-converter';

const converter = PreactHTMLConverter();
// converter.registerComponent('test', Test);

export class EstateCard extends Component {
  constructor(props) {
    super(props);
    }

    // need to add a GTM thing here for handle the (Select Item) event which is supposed to happen on click on the image or button in list view
    
  render() {
    const estateMainImage = { backgroundImage: `url(${ this.props.primaryImageUrl })` }
    const moreInfoButton = () => {
      if (this.props.url) {
        return (<div class="estate__summary__more-info">
          <a
                class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                href={this.props.url}
                target="_blank"
                onClick={ () => clicked(this.props) }
          >
            More Information
          </a>
        </div>);
      }
      return null;
    };

    return (
      <div class={`estate__summary status-${this.props.projectStatus}`}>
            <a class="estate__summary__thumbnail-wrapper" href={this.props.url} onClick={() => clicked(this.props)} target="_blank" style={estateMainImage}>
          <img class="estate__summary__thumbnail" src={this.props.primaryImageUrl} />
        </a>

        <a class="estate-logo-link" href={this.props.url} target="_blank">
          <img class="estate-logo" src={this.props.logoUrl} alt={this.props.name} />
        </a>
        <h4 class="estate__summary__title">
          <span class="estate__summary__name">{this.props.name}</span>
        </h4>
        <p class="estate__summary__address">{this.props.address}</p>
        <div class="estate__summary__description">
          {converter.convert(this.props.description)}
        </div>
        { moreInfoButton() }
      </div>
    );
  }
}

export class EstateEmptyState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="product-search__empty">
                <h2>Sorry...</h2>
                <h4>No communities found</h4>
            </div>
        )
    }

}

function clicked(props) {
    console.log('(Select Item) fired in estate')

    let community = {
        community_name: props.name,
        community_region: props.region,
        community_availability: props.projectStatus
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "select_item",
        ecommerce: {
            item_list_name: "Community List", // or Lot List
            items: [community] // the single item selected, in an array
        }
    });
}
